module.exports = __webpack_public_path__ + "img/schneeflöckchen.b219855c.jpeg";